/* eslint-disable max-lines-per-function */
import PropTypes from "prop-types";
import React from "react";
import { Column, FormRow } from "components/common/html";
import { InputBasic, SelectState } from "components/common/form";
const t = PropTypes;

export default class AddressGroup extends React.Component {
  static propTypes = {
    namespace: t.string,
    formData: t.object.isRequired,
  };

  render () {
    const { props } = this;
    return (
      <div>
        <FormRow>
          <Column width={8}>
            <InputBasic
              label={props.addressLabel || "Address"}
              name={`${props.namespace}_address1`}
              prefix={props.namespace}
              formData={props.formData}
              defaultValue={props.formData[`${props.namespace}_address1`]}
            />
          </Column>

          <Column width={4}>
            <InputBasic
              label="Suite/Floor/Apt #"
              name={`${props.namespace}_ste_number`}
              formData={props.formData}
              defaultValue={props.formData[`${props.namespace}_ste_number`]}
            />
          </Column>
        </FormRow>
        <FormRow>
          <Column width={4}>
            <InputBasic
              label="City"
              name={`${props.namespace}_city`}
              formData={props.formData}
              defaultValue={props.formData[`${props.namespace}_city`]}
            />
          </Column>

          <Column width={4}>
            <SelectState
              label="State"
              name={`${props.namespace}_state`}
              formData={props.formData}
              defaultValue={props.formData[`${props.namespace}_state`]}
            />
          </Column>

          <Column width={4}>
            <InputBasic
              label="Zip Code"
              name={`${props.namespace}_zip`}
              max={5}
              formData={props.formData}
              defaultValue={props.formData[`${props.namespace}_zip`]}
            />
          </Column>
        </FormRow>
      </div>
    );
  }
}
